import styled from 'styled-components'
import { Discount } from 'pcln-icons'

export const StyledDiscount = styled(Discount)`
  align-self: flex-start;
  ${props => props.theme.mediaQueries.sm} {
    align-self: center;
  }
`
